export default __webpack_public_path__ + "static/media/ods6.48d3aa10.svg";